import { SideMenuMobileTrigger } from '../../components/SideMenuMobileTrigger/SideMenuMobileTrigger';
import { useAssetVisibility } from './useAssetVisibility';
import { EyeButton } from '../../components/GuestBar/content/EyeButton';
import { DisplayAssetModal } from '../../components/GuestBar/DisplayAssetsModal';

export const TopPrimaryMenuItemsMobile = () => {
  const { onEyeButtonClick, handleCloseModal, handleSubmit, handleChange, handleCancel, isModalOpen, formData, assetViewMode, isImpersonationActive } =
    useAssetVisibility();

  return (
    <>
      <SideMenuMobileTrigger />
      {isImpersonationActive && assetViewMode && <EyeButton data-test-specifier="eye-button" viewMode={assetViewMode} onClick={onEyeButtonClick} />}
      {isModalOpen && (
        <DisplayAssetModal
          isOpen={isModalOpen}
          onSubmit={handleSubmit}
          onClose={handleCloseModal}
          onCancel={handleCancel}
          onChange={handleChange}
          formData={formData}
        />
      )}
    </>
  );
};
